enum LoLFormAnswerType {
  LABEL,
  RATING,
}

export { LoLFormAnswerType };
